export default class TagEmbed {
  ready () {
    window.addEventListener('load', function () {
      setTimeout(() => {
        const SCRIPT_TAG = document.createElement('script')
        SCRIPT_TAG.setAttribute('src', '//widget.tagembed.com/embed.min.js')
        SCRIPT_TAG.setAttribute('type', 'text/javascript')
        document.head.appendChild(SCRIPT_TAG)
      }, 1000)
    })
  }
}
